<template>
    <a :href="href" target="_blank">
        <img class="img-support-vip" :src="srcImg" alt="support-vip.png">
    </a>
</template>

<script>
export default {
    name: "dv5-right-banner-vip",
    props: ["vip_banner_infos", "version", "is_vip", "support_route", "routes", "is_free_plan", "app"],
    data() {
        return {
            srcImg: null,
            href: null
        }
    },
    created() {
        this.getDataToBanner(0)
    },
    methods: {
        getDataToBanner(retries) {
            let maxRetry = 120,
                vm = this;


            if(!this.vip_banner_infos && retries <= maxRetry) {
                retries+=6;
                return setTimeout(function() {
                    vm.getDataToBanner(retries);
                }, 600);
            }

            if(this.vip_banner_infos != null && this.vip_banner_infos != undefined) {
                // if (this.app == 'banners_ba5') {
                this.srcImg = this.vip_banner_infos[0].banner
                this.href = this.vip_banner_infos[0].action_link
                // } else {
                //     this.srcImg = `${ this.is_vip ? this.vip_banner_infos.img_access : this.vip_banner_infos.img_purchase}?v=${this.version}`
                //     this.href = this.is_free_plan ? this.routes.rota_office_upgrade + '?is_free_plan=true' : this.is_vip ? this.support_route : this.vip_banner_infos.link
                // }
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.img-support-vip {
    width: 350px;
    height: 60px;
    margin-bottom: 10px;
    border-radius: 4px;
}

@media screen and (max-width: 700px) {
    .img-support-vip {
        width: 100%;
        padding: 0 .6em 0 .5em;
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/banners/RightBannerVip.vue